<template lang="pug">
  #business-list
    .table-view
      .table-view-header
        .table-view-header-title
          h3 Empresas
        .table-view-header-actions
      b-table(:items="tableItems" :fields="fields" responsive)
        template(v-slot:cell(name)="{item}")
          router-link(:to="{ name:'BusinessDetail', params:{ id: item.bussinesId } }") {{item.name}}
        template(v-slot:cell(active)="{item}")
          .table-actions
            b-form-checkbox(v-model="form.businessesIds" @change="onSave()" name="businessIds" :value="item.bussinesId" switch)
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import BaseInputConfirmChange from '../common/BaseInputConfirmChange.vue'

export default {
  components: {
    BaseInputConfirmChange
  },
  data() {
    return {
      form: {
        businessesIds: []
      },
      fields: [
        {
          label: 'Nombre',
          key: 'name',
          sortable: true
        },
        {
          label: 'Activo',
          key: 'active'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['businesses', 'businessServices', 'businessGroup']),
    tableItems () {
      return this.businesses.map(b => {
        return {
          bussinesId: b.id,
          name: b.name
        }
      })
    },
  },
  watch: {
    businessGroup () {
      this.form.businessesIds = this.businessGroup ? this.businessGroup.businessesIds : []
    }
  },
  methods: {
    ...mapActions(['listBusiness', 'updateBusinessGroup']),
    async onSave () {
      await this.updateBusinessGroup({ data: this.form, groupId: this.businessGroup.id })
    }
  },
  created() {
    this.listBusiness()
    this.form.businessesIds = this.businessGroup ? this.businessGroup.businessesIds : []
  }
}
</script>
